import React from 'react';

export const AppSecIcon = () => {
  return (
    <div>
      <img src="/pictures/AppSecIcon.svg" alt="" />
    </div>
  );
};
